import { Button, Stack, Typography, styled, Badge } from "@mui/material";
import { CustomeDialog, CustomTable } from "../../../shared";
import { arraySort } from "../../../utils";

const StyledBadge = styled(Badge)(({ background }) => ({
  "& .MuiBadge-badge": {
    right: 4,
    top: 10,
    padding: "0 4px",
    position: "relative",
    background,
  },
}));

export const StockSubCategoryProductsDialog = ({
  open = false,
  title,
  productsList = [],
  handleClose,
}) => {
  const columns = [
    {
      accessorKey: "name",
      header: "Product",
    },
  ];

  return (
    <CustomeDialog
      PaperProps={{
        sx: {
          width: { xs: "90%", sm: "500px", md: "650px" },
          height: "auto",
          // maxHeight: "650px",
        },
      }}
      closeIcon={false}
      open={open}
      handleClose={handleClose}
      isHeader={false}
      content={
        <CustomTable
          defaultData={arraySort(productsList, "name")}
          columns={columns}
          headerText={
            <Stack direction="row" width="412px" alignItems="center" gap="6px">
              <Typography fontWeight={500} fontSize="16px">
                {title}
              </Typography>
              <StyledBadge
                badgeContent={productsList?.length}
                background="#0909091F"
              />
            </Stack>
          }
          isLoading={false}
          manualPagination={true}
          isPagination={false}
          stickyHeader={true}
          tableContainerStyle={{
            maxHeight: "60vh",
          }}
        />
      }
      footer={{
        display: true,
        onCancel: handleClose,
        cancelButton: (
          <Button variant="outlined" color="gray2" onClick={handleClose}>
            Close
          </Button>
        ),
      }}
    />
  );
};
